import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import TarjetaSolicitud from './TarjetaSolicitud';
import ModalDetalleSolicitud from './ModalDetalleSolicitud';
import FiltrosSolicitudes from './FiltrosSolicitudes';
import './ListaSolicitudes.css';
import { filtrarSolicitudes, getDataList } from '../../api/common';
import { Alert, Badge, Button, Card, Col, Nav, Row, Spinner } from 'react-bootstrap';

// Formularios por tipo — se usa el mismo form del create pero recibiendo
// `registroInicial` para pre-cargar los campos del documento existente.
import HorasExtrasForm from '../Registros/forms/HorasExtrasForm';
import PermisoForm from '../Registros/forms/PermisoForm';
import VacacionesForm from '../Registros/forms/VacacionesForm';
import InsumoForm from '../Registros/forms/InsumoForm';
import DotacionForm from '../Registros/forms/DotacionForm';
import CapacitacionForm from '../Registros/forms/CapacitacionForm';
import IncapacidadForm from '../Registros/forms/IncapacidadForm';
import CompensatorioForm from '../Registros/forms/CompensatorioForm';
import TeletrabajoForm from '../Registros/forms/TeletrabajoForm';
import EquipamientoForm from '../Registros/forms/EquipamientoForm';

const FORMS_POR_TIPO = {
  horasExtras: HorasExtrasForm,
  permiso: PermisoForm,
  vacaciones: VacacionesForm,
  insumo: InsumoForm,
  dotacion: DotacionForm,
  capacitacion: CapacitacionForm,
  incapacidad: IncapacidadForm,
  compensatorio: CompensatorioForm,
  teletrabajo: TeletrabajoForm,
  equipamiento: EquipamientoForm,
};

const ListaSolicitudes = () => {
  const { userData } = useAuth();
  const [solicitudes, setSolicitudes] = useState([]);
  console.log(solicitudes)
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [solicitudEditar, setSolicitudEditar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vistaActual, setVistaActual] = useState('todas');
  const [filtrosActivos, setFiltrosActivos] = useState({});
  const [estadisticas, setEstadisticas] = useState({
    total: 0,
    pendientes: 0,
    aprobadas: 0,
    rechazadas: 0
  });

  useEffect(() => {
    cargarSolicitudes();
  }, [vistaActual, filtrosActivos]);

  const cargarSolicitudes = async () => {
    setLoading(true);
    setError(null);

    try {
      let resultado;

      switch (vistaActual) {
        case 'pendientes':
          resultado = await getDataList('Registro');
          break;

        case 'mis-solicitudes':
          resultado = await filtrarSolicitudes({
            solicitante: userData._id,
            ...filtrosActivos
          });
          break;

        case 'todas':
        default:
          resultado = await getDataList('Registro')
          break;
      }

      console.log(resultado)
      if (resultado.status=200) {
        setSolicitudes(resultado.data.data);
        calcularEstadisticas(resultado.data.data);
      } else {
        setError('Error al cargar las solicitudes');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Error al cargar las solicitudes');
    } finally {
      setLoading(false);
    }
  };

  const calcularEstadisticas = (datos) => {
    setEstadisticas({
      total: datos.length,
      pendientes: datos.filter(s => s.estado === 'pendiente' || s.estado === 'en_revision').length,
      aprobadas: datos.filter(s => s.estado === 'aprobado').length,
      rechazadas: datos.filter(s => s.estado === 'rechazado').length
    });
  };

  const handleVerDetalle = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setMostrarModal(true);
  };

  const handleCerrarModal = () => {
    setMostrarModal(false);
    setSolicitudSeleccionada(null);
  };

  const handleEditarSolicitud = (solicitud) => {
    if (!FORMS_POR_TIPO[solicitud?.tipoSolicitud]) {
      console.warn('[ListaSolicitudes] No hay formulario para', solicitud?.tipoSolicitud);
      return;
    }
    setSolicitudEditar(solicitud);
  };

  const handleCerrarEditor = () => {
    setSolicitudEditar(null);
    cargarSolicitudes();
  };

  const handleActualizarLista = () => {
    cargarSolicitudes();
  };

  const handleAplicarFiltros = (filtros) => {
    setFiltrosActivos(filtros);
  };

  const handleLimpiarFiltros = () => {
    setFiltrosActivos({});
  };

  // Si el creador clickeó "Editar" en una solicitud pendiente, mostramos el
  // formulario correspondiente a pantalla completa (los forms no son modales).
  // Al cerrarlo o guardar, volvemos a la lista refrescada.
  if (solicitudEditar) {
    const FormEditar = FORMS_POR_TIPO[solicitudEditar.tipoSolicitud];
    if (FormEditar) {
      return (
        <FormEditar
          onClose={handleCerrarEditor}
          onSubmit={handleCerrarEditor}
          tipoRegistro={solicitudEditar.tipoSolicitud}
          solicitante={userData?._id}
          registroInicial={solicitudEditar}
        />
      );
    }
  }

return (
    <div className="container-fluid py-4">
      {/* Header Section */}
      <div className="row mb-4">
        <div className="col-12">
          <Card className="border-0 shadow-sm w-100">
            <Card.Body className="py-4 w-100" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
              <div className="d-flex align-items-center">
                <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
                  <i className="bi bi-clipboard-check text-white fs-3"></i>
                </div>
                <div className="text-white">
                  <h2 className="mb-1 fw-bold">Gestión de Solicitudes</h2>
                  <p className="mb-0 opacity-75">
                    <i className="bi bi-info-circle me-2"></i>
                    Administra y aprueba las solicitudes del sistema
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>

      {/* Estadísticas Cards */}
      <Row className="g-3 mb-4">
     <Col xs={12} sm={6} lg={3}>
          <Card className="border-0 shadow-sm hover-shadow w-100">
            <Card.Body className="w-100">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <p className="text-muted text-uppercase fw-semibold mb-2 small">
                    <i className="bi bi-clipboard-data me-2"></i>Total
                  </p>
                  <h2 className="mb-0 fw-bold display-6">{estadisticas.total}</h2>
                  <p className="text-muted small mb-0 mt-1">Solicitudes registradas</p>
                </div>
                <div className="bg-primary bg-opacity-10 rounded-3 p-2 d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px'}}>
                  <i className="bi bi-clipboard-data text-primary fs-3"></i>
                </div>
              </div>
            </Card.Body>
            <Card.Footer className="bg-primary bg-opacity-10 border-0 py-2 w-100">
              <small className="text-primary">
                <i className="bi bi-arrow-up-right me-1"></i>
                Sistema activo
              </small>
            </Card.Footer>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3}>
          <Card className="border-0 shadow-sm hover-shadow w-100">
            <Card.Body className="w-100">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <p className="text-muted text-uppercase fw-semibold mb-2 small">
                    <i className="bi bi-clock-history me-2"></i>Pendientes
                  </p>
                  <h2 className="mb-0 fw-bold display-6 text-warning">{estadisticas.pendientes}</h2>
                  <p className="text-muted small mb-0 mt-1">Por revisar</p>
                </div>
                <div className="bg-warning bg-opacity-10 rounded-3 p-2 d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px'}}>
                  <i className="bi bi-hourglass-split text-warning fs-3"></i>
                </div>
              </div>
            </Card.Body>
            <Card.Footer className="bg-warning bg-opacity-10 border-0 py-2 w-100">
              <small className="text-warning">
                <i className="bi bi-exclamation-circle me-1"></i>
                Requiere atención
              </small>
            </Card.Footer>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3}>
          <Card className="border-0 shadow-sm hover-shadow w-100">
            <Card.Body className="w-100">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <p className="text-muted text-uppercase fw-semibold mb-2 small">
                    <i className="bi bi-check-circle me-2"></i>Aprobadas
                  </p>
                  <h2 className="mb-0 fw-bold display-6 text-success">{estadisticas.aprobadas}</h2>
                  <p className="text-muted small mb-0 mt-1">Autorizadas</p>
                </div>
                <div className="bg-success bg-opacity-10 rounded-3 p-2 d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px'}}>
                  <i className="bi bi-check-circle-fill text-success fs-3"></i>
                </div>
              </div>
            </Card.Body>
            <Card.Footer className="bg-success bg-opacity-10 border-0 py-2 w-100">
              <small className="text-success">
                <i className="bi bi-check2 me-1"></i>
                Proceso completado
              </small>
            </Card.Footer>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3}>
        <Card className="border-0 shadow-sm hover-shadow  w-100">
            <Card.Body className="w-100">
            <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                <p className="text-muted text-uppercase fw-semibold mb-2 small">
                    <i className="bi bi-x-circle me-2"></i>Rechazadas
                </p>
                <h2 className="mb-0 fw-bold display-6 text-danger">{estadisticas.rechazadas}</h2>
                <p className="text-muted small mb-0 mt-1">No autorizadas</p>
                </div>
                <div className="bg-danger bg-opacity-10 rounded-3 p-2 d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px'}}>
                <i className="bi bi-x-circle-fill text-danger fs-3"></i>
                </div>
            </div>
            </Card.Body>
            <Card.Footer className="bg-danger bg-opacity-10 border-0 py-2 w-100">
            <small className="text-danger">
                <i className="bi bi-dash-circle me-1"></i>
                Revisión requerida
            </small>
            </Card.Footer>
        </Card>
        </Col>
      </Row>

      {/* Navigation Tabs */}
      <Row className="mb-3">
        <Col xs={12}>
          <Card className="border-0 shadow-sm w-100">
            <Card.Body className="p-2 w-100">
              <Nav variant="pills" fill className="flex-column flex-sm-row">
                <Nav.Item>
                  <Nav.Link
                    active={vistaActual === 'todas'}
                    onClick={() => setVistaActual('todas')}
                    className="rounded-pill"
                  >
                    <i className="bi bi-grid-3x3-gap me-2"></i>
                    <span className="d-none d-md-inline">Todas las </span>Solicitudes
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={vistaActual === 'pendientes'}
                    onClick={() => setVistaActual('pendientes')}
                    className="rounded-pill position-relative"
                  >
                    <i className="bi bi-hourglass-split me-2"></i>
                    <span className="d-none d-md-inline">Pendientes por </span>Aprobar
                    {estadisticas.pendientes > 0 && (
                      <Badge 
                        bg="warning" 
                        text="dark"
                        className="position-absolute top-0 start-100 translate-middle rounded-pill"
                      >
                        {estadisticas.pendientes}
                      </Badge>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={vistaActual === 'mis-solicitudes'}
                    onClick={() => setVistaActual('mis-solicitudes')}
                    className="rounded-pill"
                  >
                    <i className="bi bi-person-circle me-2"></i>
                    Mis Solicitudes
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Filtros Component */}
      <Row className="mb-3">
        <Col xs={12}>
          <FiltrosSolicitudes
            onAplicarFiltros={handleAplicarFiltros}
            onLimpiarFiltros={handleLimpiarFiltros}
            filtrosActivos={filtrosActivos}
          />
        </Col>
      </Row>

      {/* Lista de Solicitudes */}
      <Row>
        <Col xs={12}>
          {loading ? (
            <Card className="border-0 shadow-sm w-100">
              <Card.Body className="text-center py-5">
                <Spinner
                  animation="border" 
                  variant="primary" 
                  className="mb-3" 
                  style={{ width: '3rem', height: '3rem' }}
                />
                <h5 className="text-muted">Cargando solicitudes...</h5>
                <p className="text-muted small mb-0">Por favor espera un momento</p>
              </Card.Body>
            </Card>
          ) : error ? (
            <Card className="border-0 border-start border-danger border-4 shadow-sm w-100">
              <Card.Body className="w-100">
                <Alert variant="danger" className="mb-0 d-flex align-items-center">
                  <i className="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                  <div>
                    <Alert.Heading as="h5" className="mb-1">Error al cargar</Alert.Heading>
                    <p className="mb-0">{error}</p>
                  </div>
                </Alert>
              </Card.Body>
            </Card>
          ) : solicitudes.length === 0 ? (
            <Card className="border-0 shadow-sm w-100">
              <Card.Body className="text-center py-5">
                <div className="mb-4">
                  <i className="bi bi-inbox text-muted" style={{ fontSize: '5rem' }}></i>
                </div>
                <h4 className="text-muted mb-3">No hay solicitudes</h4>
                <p className="text-muted mb-4">
                  No se encontraron solicitudes con los filtros aplicados.
                  <br/>
                  Intenta ajustar los criterios de búsqueda.
                </p>
                <Button 
                  variant="outline-primary"
                  className="rounded-pill"
                  onClick={handleLimpiarFiltros}
                >
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  Limpiar Filtros
                </Button>
              </Card.Body>
            </Card>
          ) : (
            <Card className="border-0 shadow-sm w-100">
              <Card.Header className="bg-white border-bottom py-3 w-100">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <h5 className="mb-0">
                    <i className="bi bi-list-ul me-2 text-primary"></i>
                    Listado de Solicitudes
                    <Badge bg="primary" className="ms-2">{solicitudes.length}</Badge>
                  </h5>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="rounded-pill"
                    onClick={cargarSolicitudes}
                  >
                    <i className="bi bi-arrow-clockwise me-1"></i>
                    Actualizar
                  </Button>
                </div>
              </Card.Header>
              <Card.Body className="p-3 w-100">
                <Row className="g-3">
                  {solicitudes.map((solicitud) => (
                    <Col key={solicitud._id} xs={12}>
                      <TarjetaSolicitud
                        solicitud={solicitud}
                        usuarioActual={userData}
                        onVerDetalle={handleVerDetalle}
                        onActualizar={handleActualizarLista}
                      />
                    </Col>
                  ))}
                </Row>
              </Card.Body>
              <Card.Footer className="bg-light border-top py-3 w-100">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <small className="text-muted">
                    <i className="bi bi-info-circle me-1"></i>
                    Mostrando {solicitudes.length} solicitud(es)
                  </small>
                  <small className="text-muted">
                    <i className="bi bi-clock me-1"></i>
                    Última actualización: {new Date().toLocaleTimeString('es-CO')}
                  </small>
                </div>
              </Card.Footer>
            </Card>
          )}
        </Col>
      </Row>

      {/* Modal de Detalle */}
      {mostrarModal && solicitudSeleccionada && (
        <ModalDetalleSolicitud
          solicitud={solicitudSeleccionada}
          usuarioActual={userData}
          show={mostrarModal}
          onHide={handleCerrarModal}
          onActualizar={handleActualizarLista}
          onEditar={handleEditarSolicitud}
        />
      )}
    </div>
);
};


export default ListaSolicitudes;